import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 4974 13703"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g>
      <g id="_1974337314320">
        <path
          d="M3920 3583H1054c-225 0-407-182-407-407V406C647 182 829 0 1054 0c224 0 406 182 406 406v2364h2053V406c0-224 182-406 407-406 224 0 406 182 406 406v2770c0 225-182 407-406 407z"
          className="fil0"
        />
        <path
          d="M2487 3583c-225 0-407-182-407-407V406c0-224 182-406 407-406 224 0 406 182 406 406v2770c0 225-182 407-406 407zM2487 7469v-243h1060v-891H1427v349h1060v243H1427v841h1060v243H1427v348h2120v-890z"
          className="fil0"
        />
        <path
          d="M4813 13703c-1507 0-2733-1263-2733-2815V6364h813v4524c0 1104 862 2002 1920 2002v813zM638 5419l148 172h3402l148-172zM3900 5925l148-172H926l148 172zM4763 4922l211-244H0l210 244zM1213 6088l214 247h2120l213-247zM350 5085l148 171h3978l148-171zM4974 4678H0V2608h4974z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
